<app-header></app-header>
<!-- <main role="main" class="flex-shrink-0">
    <div class="container-fluid mt-5 mb-4"> -->
      <!-- <div class="container-fluid" style="float:left;" > -->
    <ngx-spinner></ngx-spinner>
    <div class="row pb-2 mt-4 ml-1 mr-1">
        <div class="col">
            <h4>
                <div>{{ CreateShowHide ? 'Add Category' : UpdateShowHide ? 'Edit Category': 'Categories'}}</div>
            </h4>
        </div>
    </div>

    <div class="row mb-2 ml-1 mr-1">
        <div class="col">
          <button type="button" *ngIf="AddShowHide" (click)="AddCategory()" class="btn btn-success float-right">
            <i class="fas fa-plus-circle"></i> <span>Add Category</span>
          </button>
        </div>
      </div>

    <form [formGroup]="frmCategory" *ngIf="CreateShowHide || UpdateShowHide">
        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-lg-4">
                        <label for="txtProductCategory">Product Category</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtProductCategory" formControlName="ProductCategory">
                    </div>
                    <div class="form-group col-lg-3">
                        <label for="txtProductCategoryTitle">Title</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtProductCategoryTitle" formControlName="ProductCategoryTitle">
                    </div>
                    <div class="form-group col-lg-1">
                        <label for="txtOrderBy">Order By</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtOrderBy" formControlName="OrderBy">
                    </div>
                </div>
            </div>
        </div>
        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-lg-7">
                        <label for=txtProductCategoryDescription>Description</label><span style="color:red;">&nbsp;*</span>
                        <textarea class="form-control" id="txtProductCategoryDescription" formControlName="ProductCategoryDescription" required aria-label="With textarea"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="row ml-1 mr-1">
            <div class="col">
              <div class="form-row">
                <div class="form-group col-lg-8">
                  <button type="button" class="btn btn-success" (click)="fileInput.click()" >Choose File</button><span style="color:red;"> *</span>
                  <input  hidden #fileInput type="file" accept=".jpg" id="file" formControlName="CategoryImage" (change)="setFilename(fileInput.files)" />
                  <label >{{ this.filename }}</label>          
                  <img *ngIf="isShown" src="{{this.baseUrl + this.productcategoryimagename}}" style="max-width:20%; height: auto;" alt="{{this.productcategoryimagename}}" title="{{this.productcategoryimagename}}">
                </div>
                 <div *ngIf="frmCategory.get('CategoryImage').invalid && frmCategory.get('CategoryImage').touched"  class="validation">
                  <small *ngIf="frmCategory.get('CategoryImage').errors.required">
                    Must be required!!!
                  </small>                  
                </div> 
              </div>
            </div>
          </div>

        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-ro"w>
                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateCategory(fileInput.files)">
                    <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
                </button>
                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateCategory(fileInput.files)">
                    <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
                </button>
                <a>
                    <button type="button" aria-controls="addCategory"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
                        <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
                    </button>
                </a>  
                </div>  
            </div>
        </div>
    </form>
    <!-- <div id="addCategory"tabindex="-1" #addCategory aria-labelledby="addCategory" aria-hidden="true" *ngIf="CreateShowHide || UpdateShowHide">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="AddCategoryTitle">Edit Category Information</h5>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmCategory">
                        <div class="form-row">

                            <div class="col-md-4 mb-2">
                                <label for="txtProductCategory">Product Category</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtProductCategory"
                                formControlName="ProductCategory"  readonly="readonly">
                            </div>
                            <div class="col-md-4 mb-2">
                              <label for="txtProductCategoryTitle">Title</label><span style="color:red;">&nbsp;*</span>
                              <input type="text" class="form-control" id="txtProductCategoryTitle"
                              formControlName="ProductCategoryTitle"  readonly="readonly">
                          </div>
                            <div class="col-md-12 mb-2">
                              <label for=txtProductCategoryDescription>Description</label><span style="color:red;">&nbsp;*</span>
                              <textarea class="form-control" id="txtProductCategoryDescription" formControlName="ProductCategoryDescription" required
                                aria-label="With textarea"></textarea>
                            </div>                      

                           
                          </div>
                        <div class="modal-footer">
                          <div class="row">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateCategory()">Add</button>
                                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateCategory()">Update</button>
                            </div> 
                            <div class="col-md-6">   
                                <button type="button" data-target="#addCategory" aria-controls="addCategory"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary" >Cancel</button>
                            </div>
                        </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div> -->
    <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            <th scope="col"><span (click)="SortOder('ProductCategory1')">Product Category <i class="fas fa-sort"></i></span></th>
                            <th scope="col">Description</th>
                            <th scope="col">Title</th>
                            <th scope="col">Order By</th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config ">
                            <td *ngIf="EditShowHide">
                              <tr>
                                <td>
                                  <button type="button" class="btn btn-info btn-sm"
                                          (click)="EditCategory(item)" title="Edit">
                                    <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                  </button>
                                </td>
                                <td>
                                <button class="btn btn-info btn-sm" (click)="DeleteCategory(item.Id)" title="Delete">
                                  <i class="far fa-trash-alt fa-lg text-danger"></i>
                                  <span class="d-none d-md-inline d-lg-inline">Delete</span>
                                </button>
                                </td>
                              </tr>
                          </td>
                            <td>{{item.ProductCategory1}}</td>
                            <td>{{item.ProductCategoryDescription}}</td>
                            <td>{{item.ProductCategoryTitle}}</td>
                            <td>{{item.OrderBy}}</td>

                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;">
                                <pagination-controls (pageChange)="pageChanged($event)" id="Category"></pagination-controls>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>

    <!-- <div class="modal fade" id="addCategory"tabindex="-1" #addCategory aria-labelledby="addCategory"aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="AddCategoryTitle">Enter Category Information</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmCategory">
                        <div class="form-row">

                            <div class="col-md-4 mb-2">
                                <label for="txtProductCategory">Product Category</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtProductCategory"
                                formControlName="ProductCategory"  readonly="readonly">
                            </div>
                            <div class="col-md-4 mb-2">
                              <label for="txtProductCategoryTitle">Title</label><span style="color:red;">&nbsp;*</span>
                              <input type="text" class="form-control" id="txtProductCategoryTitle"
                              formControlName="ProductCategoryTitle"  readonly="readonly">
                          </div>
                            <div class="col-md-12 mb-2">
                              <label for=txtProductCategoryDescription>Description</label><span style="color:red;">&nbsp;*</span>
                              <textarea class="form-control" id="txtProductCategoryDescription" formControlName="ProductCategoryDescription" required
                                aria-label="With textarea"></textarea>
                            </div>                      

                           
                          </div>
                        <div class="modal-footer">
                          <div class="row">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateCategory()">Add</button>
                                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide"data-toggle="modal" data-dismiss="modal" (click)="UpdateCategory()">Update</button>
                            </div> 
                            <div class="col-md-6">   
                                <button type="button" data-target="#addCategory" data-toggle="modal" aria-controls="addCategory"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            <th scope="col"><span (click)="SortOder('ProductCategory1')">Product Category <i class="fas fa-sort"></i></span></th>
                            <th scope="col">Description</th>
                            <th scope="col">Title</th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config ">
                            <td *ngIf="EditShowHide">
                                <button type="button"  data-target="#addCategory" data-toggle="modal" class="btn btn-info btn-sm"
                                (click)="EditCategory(item)" title="Edit"><i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                </button>
                            </td>
                            <td>{{item.ProductCategory1}}</td>
                            <td>{{item.ProductCategoryDescription}}</td>
                            <td>{{item.ProductCategoryTitle}}</td>

                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;">
                                <pagination-controls (pageChange)="pageChanged($event)" id="Category"></pagination-controls>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div> -->
    <!-- </div> -->
